import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/salon-vista-mesas.webp")